export default "__VITE_ASSET__57d45042__"